import React from 'react';

function VideoPlayer({ video, onPlay }) {
  return (
    <div className="featured-tile">
      <p className="featured-label">Featured Performance</p>
      {video.title && <h2>{video.title}</h2>}
      <div className="video-embed">
        <iframe
          src={`https://www.youtube-nocookie.com/embed/${video.url}?rel=0&enablejsapi=1&origin=${window.location.origin}`}
          title={video.title || 'Video'}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          onLoad={onPlay}
          referrerPolicy="strict-origin-when-cross-origin"
        />
      </div>
    </div>
  );
}

export default VideoPlayer;
